const base_url =   {
   
 /*   
"base_url":"http://localhost:5000/website",
    "base":"http://localhost:5000"
    // 
    */


   "base_url":"https://api.kichaarojes.in/website",
    "base":"https://api.kichaarojes.in"
}


export default  base_url 